import { createAction, stringDuckCreator } from '@atc/modular-redux';

export default function serviceDealerCreator({
    namespace = '',
    store = 'serviceDealer',
    storePrefix,
    initialState = '',
} = {}) {
    return stringDuckCreator({
        initialState,
        namespace,
        store,
        storePrefix,
    }).extend({
        creators: ({ types }) => ({
            setValue: createAction(types.SET),
        }),
    });
}
